import { Region } from '~/shared/api/region'
import { Filter } from '~/shared/ui/AsyncGrid'

export const filters: Filter[] = [
  {
    field: 'name',
    label: 'Название',
    type: 'text',
  },
  {
    field: 'regions',
    label: 'Регион',
    type: 'autocomplete',
    fetchOptions: Region.fetchOptions,
  },
]
